import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/connect_16.svg.ts
import { svg } from "lit";
var connect16Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_6716_7405)">
    <path d="M6.59204 8.70469C6.89437 9.10927 7.28008 9.44403 7.72301 9.68627C8.16595 9.92851 8.65575 10.0726 9.1592 10.1087C9.66264 10.1447 10.1679 10.072 10.6409 9.89545C11.1138 9.71886 11.5432 9.44254 11.9 9.08522L14.0119 6.97117C14.6531 6.30665 15.0079 5.41662 14.9999 4.4928C14.9919 3.56897 14.6217 2.68525 13.9691 2.03198C13.3165 1.37871 12.4336 1.00816 11.5107 1.00013C10.5878 0.992105 9.69869 1.34725 9.03484 1.98906L7.824 3.19407" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.40798 7.29529C9.10565 6.89071 8.71994 6.55595 8.27701 6.31371C7.83407 6.07147 7.34427 5.92742 6.84082 5.89133C6.33738 5.85523 5.83207 5.92795 5.35917 6.10453C4.88627 6.28111 4.45684 6.55744 4.1 6.91476L1.98807 9.02881C1.3469 9.69333 0.992113 10.5834 1.00013 11.5072C1.00815 12.431 1.37833 13.3147 2.03095 13.968C2.68356 14.6213 3.56639 14.9918 4.48929 14.9998C5.4122 15.0079 6.30132 14.6527 6.96518 14.0109L8.16898 12.8059" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_7405">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;
export {
  connect16Svg
};
//# sourceMappingURL=connect_16.svg-NSXNVWXM.js.map
